import { inject, Pipe, PipeTransform } from '@angular/core';
import { InvoiceStatusPipe } from '../../feature/invoice/pipes/invoice-status.pipe';
import { OfferStatusPipe } from '../../feature/offer/pipes/offer-status.pipe';
import { DeliveryNoteStatusPipe } from '../../feature/delivery-note/pipes/delivery-note-status.pipe';
import { OrderStatusPipe } from '../../feature/order/pipes/order-status.pipe';
import { DocType } from '../enum/document-type.enum';
import { ContractStatusPipe } from '../../feature/contract/pipes/contract-status.pipe';

@Pipe({
  name: 'statusConverter',
  standalone: true
})
export class StatusConverterPipe implements PipeTransform {
    private readonly offerStatusPipe = inject(OfferStatusPipe);
    private readonly orderStatusPipe = inject(OrderStatusPipe);
    private readonly deliveryNoteStatusPipe = inject(DeliveryNoteStatusPipe);
    private readonly invoiceStatusPipe = inject(InvoiceStatusPipe);
    private readonly contractStatusPipe = inject(ContractStatusPipe);

  transform(status: any, documentType: any): string {
    if (status == null || status == undefined)
      return 'Unknown';

    const docTypeStr = typeof documentType == 'string' ? documentType.toLowerCase() : null;

    if(documentType == DocType.Offer || docTypeStr == 'offer')
      return this.offerStatusPipe.transform(status);
    else if(documentType == DocType.OrderConfirmation || docTypeStr == 'orderconfirmation')
      return this.orderStatusPipe.transform(status);
    else if(documentType == DocType.DeliveryNote || docTypeStr == 'deliverynote')
      return this.deliveryNoteStatusPipe.transform(status);
    else if(documentType == DocType.Invoice || docTypeStr == 'invoice')
      return this.invoiceStatusPipe.transform(status);
    else if(documentType == DocType.FrameworkContract || docTypeStr == 'frameworkcontract' ||
            documentType == DocType.ServiceContract || docTypeStr == 'servicecontract')
      return this.contractStatusPipe.transform(status);
    else
      return 'Unknown';

  }
}


